export default __webpack_public_path__ + "static/media/circleDot.2f5db1b4.svg";